import React from 'react'
import ReactDOM from 'react-dom/client'

import { HomeDetail, type HomeDetailProps } from '../pages/home'
import '../pages/home/home.less'
import { getInitData } from './public/getInitData'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  // const data = window.__INITIAL_DATA__
  const data = getInitData<HomeDetailProps>()
  root.render(
    <React.StrictMode>
      <HomeDetail {...data} />
    </React.StrictMode>
  )
}
